import { graphql } from "relay-runtime"

export const deCreateOrUpdatePatientBodyMeasurementMutation = graphql`
  mutation deCreateOrUpdatePatientBodyMeasurementMutation(
    $input: De_createOrUpdatePatientBodyMeasurementInput!
    $connections: [ID!]!
  ) {
    createOrUpdatePatientBodyMeasurement: de_createOrUpdatePatientBodyMeasurement(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on InvalidWeight {
          message
        }
        ... on InvalidHeight {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      bodyMeasurement @prependNode(connections: $connections, edgeTypeName: "BodyMeasurementsEdge") {
        id
        date
        height
        weight
        bodyMassIndex
      }
    }
  }
`
